<template>
  <span
    class="h-2 w-2 rounded-full shrink-0"
    :style="{ backgroundColor: color ?? NO_TYPE_COLOR }"
    :title="title"
  />
</template>

<script setup lang="ts">
// The job-type color dot — single owner of the dot markup so size/contrast
// changes don't have to chase copies across the badge, comboboxes, and cards.
import { NO_TYPE_COLOR } from '@/lib/typeColors'

defineProps<{ color?: string | null; title?: string }>()
</script>
